import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BrickSnake2000} from "../../BrickSnake2000";
import {BrickSnake2000XWaysSymbol} from "../../reels/symbols/XWaysSymbol";
import {CollectorSymbol} from "../../reels/symbols/CollectorSymbol";
import {FreespinsMultiplierSymbol} from "../../reels/symbols/FreespinsMultiplierSymbol";

export class UpdateCoins implements SimplePresentation {

    name:string = "UpdateCollector";

    constructor() {
    }

    shouldRun():boolean {
        return BrickSnake2000.freespinsReelView.getFsMultiplier() > 1;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline({
            onStart: () => {
                controller.setSkipCallback(() => {tl.seek("End", false)});
            },
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish()
            }
        });


        tl.add(BrickSnake2000.freespinsReelView.blinkFsMultiplier(), '>0.4');
        tl.add(() => {
            BrickSnake2000.soundPlayer.playSound("multiplierDisplayUpdate");
        }, '<')
        tl.add(() => {
            const oldMultiplier = 1;
            const newMultiplier = BrickSnake2000.freespinsReelView.getFsMultiplier();
            BrickSnake2000.freespinsReelView.getAllSymbols()
                .filter((sym) => sym.symbolName == "MU")
                .forEach((sym) => {
                    (<FreespinsMultiplierSymbol>sym).updateValue(oldMultiplier, newMultiplier)
                })
            {BrickSnake2000.soundPlayer.playSound("coinMultiUpdate")};
        }, '>0.4');

        tl.add(() => {}, '>0.5');
        tl.addLabel("End")
    }
}
